import PublicOffer from './PublicOffer'
import './PublicOffer.css'

export default PublicOffer


// WEBPACK FOOTER //
// ./src/features/PublicOffer/components/PublicOffer/index.js